import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { Toaster } from "./components/ui/sonner";
import "./App.css";

import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Pipeline from "./pages/Pipeline";
import Expenses from "./pages/Expenses";
import PayAtClosing from "./pages/PayAtClosing";
import Compliance from "./pages/Compliance";
import Goals from "./pages/Goals";
import Archives from "./pages/Archives";
import Scripts from "./pages/Scripts";
import Listing from "./pages/Listing";
import Buyer from "./pages/Buyer";
import Tools from "./pages/Tools";
import Tiers from "./pages/Tiers";
import Glossary from "./pages/Glossary";
import Admin from "./pages/Admin";
import Recruit from "./pages/Recruit";
import Clients from "./pages/Clients";
import Calculator from "./pages/Calculator";
import ClientLeads from "./pages/ClientLeads";
import Newsletter from "./pages/Newsletter";
import Contacts from "./pages/Contacts";
import PropertyBoost from "./pages/PropertyBoost";
import PublicBoost from "./pages/PublicBoost";
import OpenHouses from "./pages/OpenHouses";
import PublicOpenHouse from "./pages/PublicOpenHouse";
import PublicSurvey from "./pages/PublicSurvey";
import Shell from "./components/layout/Shell";

function Protected({ children, adminOnly }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="p-12">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/" replace />;
  return <Shell>{children}</Shell>;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/recruit" element={<Recruit />} />
            <Route path="/clients" element={<Clients />} />
            <Route path="/calculator" element={<Calculator />} />
            <Route path="/l/:slug" element={<PublicBoost />} />
            <Route path="/oh/:slug" element={<PublicOpenHouse />} />
            <Route path="/oh/:slug/survey" element={<PublicSurvey />} />
            <Route path="/login" element={<Login />} />
            <Route path="/" element={<Protected><Dashboard /></Protected>} />
            <Route path="/pipeline" element={<Protected><Pipeline /></Protected>} />
            <Route path="/expenses" element={<Protected><Expenses /></Protected>} />
            <Route path="/pay-at-closing" element={<Protected><PayAtClosing /></Protected>} />
            <Route path="/compliance" element={<Protected><Compliance /></Protected>} />
            <Route path="/goals" element={<Protected><Goals /></Protected>} />
            <Route path="/archives" element={<Protected><Archives /></Protected>} />
            <Route path="/scripts" element={<Protected><Scripts /></Protected>} />
            <Route path="/listing" element={<Protected><Listing /></Protected>} />
            <Route path="/buyer" element={<Protected><Buyer /></Protected>} />
            <Route path="/tools" element={<Protected><Tools /></Protected>} />
            <Route path="/newsletter" element={<Protected><Newsletter /></Protected>} />
            <Route path="/contacts" element={<Protected><Contacts /></Protected>} />
            <Route path="/boost" element={<Protected><PropertyBoost /></Protected>} />
            <Route path="/open-houses" element={<Protected><OpenHouses /></Protected>} />
            <Route path="/tiers" element={<Protected><Tiers /></Protected>} />
            <Route path="/glossary" element={<Protected><Glossary /></Protected>} />
            <Route path="/admin" element={<Protected adminOnly><Admin /></Protected>} />
            <Route path="/client-leads" element={<Protected adminOnly><ClientLeads /></Protected>} />
            {/* Any unknown route (including retired ones like /story) falls back to Dashboard. */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Toaster position="top-right" />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
